export default __webpack_public_path__ + "static/media/Erlik's Scythe of the Reaper.72de4169.jpg";